module.exports = __webpack_public_path__ + "img/P150T_weapon_139.2360e7a6.png";